import { connect } from "react-redux"
import { compose } from "recompose"

export const withStyle = compose(
  connect(state => ({
    style: state.style,
  }))
)

export default withStyle



// WEBPACK FOOTER //
// ./src/hoc/withStyle.js